/*
 * @Author: WUJUN
 * @Date: 2019-07-09 11:52:34
 * @LastEditTime: 2021-06-16 15:17:45
 * @LastEditors: Please set LastEditors
 * @Description:
 */
import { parseTime } from './index';
import { payIdEnum } from './enum';
import Vue from 'vue';
const filters = {
  date: (value) => {
    return value ? parseTime(value) : '';
  },

  // 强制转换为n位小数
  toDecimal: (x, n = 2) => {
    if (x || x === 0) {
      let f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      f = Math.round(x * 100) / 100;
      let s = f.toString();
      let rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + n) {
        s += '0';
      }
      return s;
    } else {
      return '';
    }
  },

  // 分转元
  fen2yuan: (fen = 0) => {
    try {
      let n = fen;
      if (!n) {
        n = 0;
      }
      if (n || n === 0) {
        let num;
        num = n * 0.01;
        num = String(num);
        let reg = num.indexOf('.') > -1 ? new RegExp(/(\d{1,3})(?=(?:\d{3})+\.)/g) : new RegExp(/(\d{1,3})(?=(?:\d{3})+$)/g);
        num = num.replace(reg, '$1');
        num = filters.toDecimal(num);
        return num;
      } else {
        return '';
      }
    } catch (e) {
      return 0;
    }
  },
  // 手机号中间4位打星号
  formatMobile: (mobile = '') => {
    try {
      if (!mobile) {
        return '';
      }
      const reg = /(\d{3})\d{4}(\d{4})/;
      return String(mobile).replace(reg, '$1****$2');
    } catch (e) {
      return '';
    }
  },
  payType: (type) => {
    let obj = {
      [payIdEnum.WX_H5]: '微信支付',
      [payIdEnum.WX_JSAPI]: '微信支付',
      [payIdEnum.ALIPAY]: '支付宝支付'
    };
    return obj[type] || type;
  }
};

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});



// WEBPACK FOOTER //
// src/utils/filter.js